
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalPluggedNoCharge75 as ObiBatteryHorizontalPluggedNoCharge75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-plugged-no-charge-75.js';
 
 
 

 
 export const ObiBatteryHorizontalPluggedNoCharge75 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-plugged-no-charge-75',
   elementClass: ObiBatteryHorizontalPluggedNoCharge75Element,
   events: {
     
   }
  });
 
 